import { createFileRoute } from "@tanstack/react-router";

import QuestRules from "@/components/QuestProfile/QuestRules";

const Component = () => {
  const { questUuid } = Route.useParams();
  return <QuestRules questUuid={questUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/loyalty/quests/$questUuid/profile/rules")({
  component: Component,
});
